import _classCallCheck from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { Game } from "../api";
import "../common";
import { BaseResource } from "@kgsport-cms/common";
export var GameService = /*#__PURE__*/function (_BaseResource) {
  _inherits(GameService, _BaseResource);
  var _super = _createSuper(GameService);
  function GameService() {
    _classCallCheck(this, GameService);
    return _super.apply(this, arguments);
  }
  _createClass(GameService, [{
    key: "gameList",
    value: function gameList(params) {
      return this.requester.get(Game.queryFirst, {
        params
      });
    }
  }, {
    key: "gameNewList",
    value: function gameNewList(params) {
      return this.requester.get(Game.queryNewFirst, {
        params
      });
    }
  }, {
    key: "gameWcBarList",
    value: function gameWcBarList() {
      return this.requester.post(Game.queryFirst6, {
        settingType: "six_navigation"
      });
    }
  }, {
    key: "gameSub",
    value: function gameSub(params) {
      return this.requester.get(Game.querySecond, {
        params
      });
    }
  }, {
    key: "gameSubToken",
    value: function gameSubToken(params) {
      return this.requester.get(Game.querySecondToken, {
        params
      });
    }
  }, {
    key: "jump",
    value: function jump(params) {
      return this.requester.get(Game.play, {
        params
      });
    }
  }, {
    key: "tryPlay",
    value: function tryPlay(params) {
      return this.requester.get(Game.freePlay, {
        params
      });
    }
  }, {
    key: "reclaimAmount",
    value: function reclaimAmount(params) {
      return this.requester.post(Game.reclaimLiveAmount, params);
    }
  }, {
    key: "transfer",
    value: function transfer(params) {
      return this.requester.get(Game.freeTransfer, {
        params
      });
    }
  }, {
    key: "getGameLotteryResult",
    value: function getGameLotteryResult(params) {
      return this.requester.get(Game.lotteryResult, {
        params
      });
    }
  }, {
    key: "getGameLotteryResultInfo",
    value: function getGameLotteryResultInfo(params) {
      return this.requester.get(Game.lotteryResultInfo, {
        params
      });
    }
    // 获取收藏游戏列表
  }, {
    key: "getGameRecommendList",
    value: function getGameRecommendList(params) {
      return this.requester.get(Game.getCollectGame, {
        params
      });
    }
    // 收藏游戏
  }, {
    key: "collectGame",
    value: function collectGame(params) {
      return this.requester.get(Game.collectGame, {
        params
      });
    }
    // 获取二级游戏导航
  }, {
    key: "getTwoGameNav",
    value: function getTwoGameNav(params) {
      return this.requester.get(Game.towGameNav, {
        params
      });
    }
    // 游戏投注列表
  }, {
    key: "getGameBetList",
    value: function getGameBetList() {
      return this.requester.get(Game.getGameBetList);
    }
    // 登录状态获取小游戏参数
  }, {
    key: "getGameParamsByToken",
    value: function getGameParamsByToken() {
      return this.requester.get(Game.getGameParamsByToken);
    }
    // 未登录状态获取小游戏参数
  }, {
    key: "getGameParams",
    value: function getGameParams() {
      return this.requester.get(Game.getGameParams);
    }
  }]);
  return GameService;
}(BaseResource);